/**
 * defined组件的配置项
 */
import returnGoods from 'allpages/orderCenter/returngood/returnGoods.vue';
import returnAmount from 'allpages/orderCenter/returngood/returnAmount.vue';
import remark from 'allpages/strategyPlatform/preformAction.vue'
import paySearchOri from 'allpages/orderCenter/pay/paySearchOri.vue';
import sourceBillNo from 'allpages/orderCenter/extraRefund/sourceBillNo.vue';
import AUDITID from 'allpages/orderCenter/returnOrder/ownerName.vue';
import preSale from 'allpages/strategyPlatform/preSale.vue'
import importMatrix from '@/component/importMatrix';
import fieldDefined from 'allpages/commodityCenter/fieldDefined.vue';
import LOGISTICS_NUMBER from 'allpages/financeCenter/LOGISTICS_NUMBER.vue';
import IS_EQUAL_EXCHANGE from '@/views/modal/organizationCenter/IS_EQUAL_EXCHANGE.vue'
import SELECT_DATE from 'allpages/reportCenter/SELECT_DATE.vue';
import extendedAttrs from 'allpages/commodityCenter/extendedAttrs.vue';
import CATEGORY_NAME from 'allpages/basicData/CATEGORY_NAME.vue';
import IDENTIFY_CONTENT from 'allpages/financeCenter/IDENTIFY_CONTENT.vue';
import ADD_SKU from 'allpages/commodityCenter/ADD_SKU.vue';


let custommizeMain = {
  IDENTIFY_CONTENT, // 财审策略-明细表
  CATEGORY_NAME, // 商品品类列表-类目名称
  PS_C_PRODIM_ID: CATEGORY_NAME, // TOC仓库辐射设置列表-商品品类
  PARENT_ID_DEFIEND: CATEGORY_NAME, // 商品品类单对象-父级类目名称
  MODIFIERNAME: CATEGORY_NAME, // 商品SPU单对象、TOB商品寻源单对象-商品品类
  PS_C_PRODIM_ITEM_ID: CATEGORY_NAME, // 寻源前拆单策略单对象-按品类拆单-商品品类
  PS_C_CATEGORY_ID: CATEGORY_NAME, // TOC仓库辐射设置单对象-商品品类
  IS_EQUAL_EXCHANGE: IS_EQUAL_EXCHANGE,
  REDUNDANT_ORDER_ID: paySearchOri,
  VERSION: returnGoods,
  PRO_ACTUAL_AMT:returnAmount,
  REMARK: remark,
  SOURCE_BILL_NO:sourceBillNo,
  AUDIT_ID:AUDITID,
  ST_C_CUSTOM_PRESELL_STRATEGY_ITEM:preSale,   //自定义预售策略，满足条件
  FILTER_VP_C_VIP_IDS: importMatrix, // 会员积分消费活动单对象-排除会员
  ECODE: fieldDefined, // 商品款号单对象-商品编码
  PARSE_NUMBER: fieldDefined, // 品牌匹配表单对象-商品编码
  LOGISTICS_NUMBER: LOGISTICS_NUMBER, // 物流费用差异处理新增-物流单号
  SELECT_DATE: SELECT_DATE, // OMS与SAP寄售库存核对-查询时间
  M_DIM1_BIGINT: extendedAttrs, // 平台店铺档案单对象-扩展属性表单
  OWNERNAME: extendedAttrs, // 商品SPU单对象-商品属性表单
  OWNERID: extendedAttrs, // 商品SKU单对象-商品属性表单
  MODIFIERENAME: ADD_SKU, // 商品SPU单对象-商品SKU表格
}
export default custommizeMain;
